import { IHttpService } from "../../core/service/HttpService";

export interface IAuthenticationService {
  login(
    username: string,
    password: string,
    verificationCode?: string
  ): Promise<any>;
  logout(): void;
  changePassword(
    newPassword: string,
    oldPassword: string,
    username: string
  ): void;
}

const AuthenticationService = ({ httpService }): IAuthenticationService => {
  const _http: IHttpService = httpService;
  const _basePath = "/dologin";
  const _passwordPath = "/api/password";

  return {
    async login(username: string, password: string) {
      const response = await _http.post(_basePath, {
        form: true,
        params: {
          password,
          username
        }
      });
      const { languageCode } = await _http.toJSON(response);
      return { languageCode };
    },

    async logout() {
      let url = _http.buildPath("/logout");
      await _http.post(url);
    },
    async changePassword(
      newPassword: string,
      oldPassword: string,
      username: string
    ) {
      const response = await _http.post(_passwordPath, {
        form: true,
        params: {
          newPassword,
          oldPassword,
          username
        }
      });
      return _http.toText(response);
    }
  };
};

export default AuthenticationService;
